import { render, staticRenderFns } from "./OCDocPendiente.vue?vue&type=template&id=517c87ac&scoped=true&"
import script from "./OCDocPendiente.vue?vue&type=script&lang=js&"
export * from "./OCDocPendiente.vue?vue&type=script&lang=js&"
import style0 from "./OCDocPendiente.vue?vue&type=style&index=0&id=517c87ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c87ac",
  null
  
)

export default component.exports